import React from "react";
import NewCardComponent from "../../NewCommon/NewCardComponent/NewCardComponent";
import { AllImages } from "../../Assets/Images/AllImages";
import "./RecentWorks.scss";
import user from "../../Common/JsonFiles/rohan.json";
const RecentWorks = () => {
  return (
    <div className="recent-works-container">
      <div className="recent-work-title">My Recent Works</div>

      <div className="recent-work-subheading">
        Here are a few past design projects I've worked on.
      </div>

      <div className="recent-work-cards">
        {user.projects.map((item) => {
          return (
            <NewCardComponent
              text={item.description}
              cardImage={AllImages[item.img]}
              btnName={item.buttonName}
              url={item.url}
            />
          );
        })}

        {/* <NewCardComponent
          text={""}
          cardImage={AllImages.card2}
          btnName="Check on Github"
        />
        <NewCardComponent
          text={""}
          cardImage={AllImages.card3}
          btnName="Check on Github"
        />
        <NewCardComponent cardImage={AllImages.card4} /> */}
      </div>
    </div>
  );
};

export default RecentWorks;
